<script>
	import { cartStore } from '../../stores/cart.store';
	import { currencyFormatter } from '../utils';
	export let item;
	const onAddToCart = () => {
		cartStore.update((items) => {
			const isInCart = items.find((i) => i.id === item.id);
			if (isInCart) {
				return items.map((i) => {
					if (i.id === item.id) {
						return {
							...i,
							quantity: i.quantity + 1,
						};
					}
					return i;
				});
			}
			if (!isInCart) {
				return [
					...items,
					{
						...item,
						quantity: 1,
					},
				];
			}
		});
	};
	$: isInCart = $cartStore.find((x) => x.id === item.id);
</script>

<div class="product-item">
	<div class="overlay">
		<div class="product-thumb">
			<img src={item.imgSrc} alt="" />
		</div>
		{#if item.isSale}
			<span class="discount">50%</span>
		{/if}
	</div>
	<div class="product-info">
		<div>{item.name}</div>
		<h4>
			{currencyFormatter.format(item.price)}
		</h4>
	</div>
	<ul class="icons">
		<li on:click={onAddToCart}><i class="bx bx-cart" /></li>
	</ul>
	{#if isInCart}
		<span class="success">
			<i class="bx bx-check" />
			Added to cart {isInCart.quantity} item(s)
		</span>
	{/if}
</div>

<style>
	.success {
		position: absolute;
		top: 10px;
		left: 10px;
		background: #4caf50;
		color: #fff;
		padding: 5px 10px;
		border-radius: 5px;
		font-size: 12px;
	}
</style>
